import { wrapContained as withStyle, stylesIf, themeColor } from 'utils/styles'
import styled from '@emotion/styled'
import {
  TextInput,
  SelectMenu,
  NumberInput,
  Switch,
} from 'components/patterns/Inputs'
import { RadioButtonGroup, Icon, Button } from 'components/patterns'
import TextInputMask from 'components/patterns/Inputs/TextInputMask'

export default withStyle(
  (props) => `
  `
)

export const StyledModuleName = styled.span`
  font-weight: bold;
`

export const RadioButtonGroupStyled = styled(RadioButtonGroup)((props) => {
  const { isPreCreate } = props
  const precreateStyle = `
    margin-top: 10px; 
  `
  return `
    ${stylesIf(isPreCreate, precreateStyle)}
  `
})

export const ReleaseNumberInputStyled = styled(TextInput)((props) => {
  const { isPreCreate } = props
  const precreateStyle = `
    margin-top: 10px; 
  `
  return `
    width: 100px;
    ${stylesIf(isPreCreate, precreateStyle)}
  `
})

export const StyledDescriptionInput = styled.div`
  margin-bottom: 2px;
`

export const StyledSubgroupSelectMenu = styled(SelectMenu)((props) => {
  const { isPreCreate } = props
  const precreateStyle = `
    margin-top: 10px; 
  `
  return `
    .ant-select {
      width: 300px;
    }
    ${stylesIf(isPreCreate, precreateStyle)}
  `
})

export const NumberInputStyled = styled(NumberInput)((props) => {
  const { isPreCreate } = props
  const precreateStyle = `
    margin-top: 20px; 
  `
  return `
    ${stylesIf(isPreCreate, precreateStyle)}
  `
})

export const TextInputMaskStyled = styled(TextInputMask)((props) => {
  const { isPreCreate } = props
  const precreateStyle = `
    margin-top: 20px; 
  `
  return `
    ${stylesIf(isPreCreate, precreateStyle)}
  `
})

export const StyledBusSwitch = styled(Switch)`
  margin-bottom: 10px;
`

export const InfoIcon = styled(Icon)`
  fill: ${themeColor('blackSecondary')};
  &&& {
    height: 14px;
    width: 24px;
    top: 12px;
    left: 13px;
  }
`

export const SchoolBusMessage = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 15px;
`

export const ConfirmIcon = styled(Icon)`
  fill: ${themeColor('errorPrimary')};
  &&& {
    height: 18px;
    width: 22px;
    top: 12px;
    left: 13px;
  }
`

export const ConfirmTitle = styled.div`
  margin-top: -22px;
  margin-left: 10px;
`

export const StyledButton = styled(Button)`
  &.ant-btn-text {
    background-color: transparent;
    border: 0;
    color: ${themeColor('bluePrimary')};
    display: flex;
    gap: 4px;
    align-items: center;
    margin-left: 0;
    margin-bottom: 0;
    font-size: 12px;
    width: fit-content;
    height: auto;
    box-shadow: none;

    :hover {
      background-color: transparent;
      border: 0 !important;
      color: ${themeColor('bluePrimary')};
    }

    & svg {
      width: 16px;
      height: 16px;
      margin: 0 !important;
      & path {
        fill: ${themeColor('bluePrimary')};
      }
    }
  }
`

export const FeatureEditorStyledContainer = styled.div`
  overflow: auto;
  padding-right: 10px;
  margin-left: -20px;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track:vertical {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:vertical {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }

  & .confirm-obsolete-overlay {
    padding-left: 20px;
    & h3 {
      font-size: 16px;
      margin-bottom: 8px;
      color: ${themeColor('blackSecondary')};
    }
    & p {
      font-weight: normal;
      font-size: 14px;
    }
  }

  & .confirm-obsolete-footer {
    display: flex;
    justify-content: space-between;
    margin-left: 16px;
  }
`

export const EditorInnerStyledContainer = styled.div`
  margin-left: 20px;
  overflow: hidden;
`

export const NotesContainer = styled.div`
  padding-left: 20px;
`
